export const tlThrottle = {
  mounted(el, binding) {
    const delay = binding.arg ? parseInt(binding.arg) : 1000;
    let timer: number | null = null;
    let originalClickHandler: EventListener;

    // 保存原始点击事件
    if (el.onclick) {
      originalClickHandler = el.onclick;
    }

    // 创建防抖处理函数
    const debounceHandler = (e: Event) => {
      if (timer) {
        clearTimeout(timer);
        timer = null;
      }

      // 禁用按钮
      el.classList.add("is-disabled");
      el.setAttribute("disabled", "true");

      timer = window.setTimeout(() => {
        // 恢复按钮状态
        el.classList.remove("is-disabled");
        el.removeAttribute("disabled");

        // 执行原始点击事件
        if (originalClickHandler) {
          originalClickHandler.call(el, e);
        } else if (binding.value) {
          binding.value(e);
        }
      }, delay);
    };

    // 存储处理函数用于卸载时清理
    el._debounceHandler = debounceHandler;
    el.addEventListener("click", debounceHandler);
  },
  unmounted(el) {
    if (el._debounceHandler) {
      el.removeEventListener("click", el._debounceHandler);
      delete el._debounceHandler;
    }
  }
};
